import { Card } from '@etg/wings';
import { css, cx, getTextStyles } from '@eti/styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const cardStyle = css`
  h2 {
    font-size: 1.125rem;
    font-weight: 700;
    margin-bottom: 16px;
  }

  ul {
    padding-inline: 8px;
  }
`;
const ProductDrawerCard = _ref => {
  let {
    cardTitle,
    children,
    className
  } = _ref;
  return /*#__PURE__*/_jsxs(Card, {
    className: cx(getTextStyles(), className || cardStyle),
    padding: 16,
    children: [/*#__PURE__*/_jsx("h2", {
      children: cardTitle
    }), children]
  });
};
export default ProductDrawerCard;
//# sourceMappingURL=ProductDrawerCard.js.map